/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type GroupByPiiKind = (typeof GroupByPiiKind)[keyof typeof GroupByPiiKind];

export const GroupByPiiKind = {
  pii: 'pii',
} as const;
